// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"277":"4937af1e","357":"4937af1e"}[chunkId] + ".chunk.css";
};